import { IconTrust12, IconWarning16 } from '@cian/ui-kit';
import * as React from 'react';

import { ELabelType } from '../types/newbuildingHeader';

export const BACKGROUND_COLOR = {
  [ELabelType.Reliable]: 'primary_10',
  [ELabelType.Problem]: 'error_100',
  [ELabelType.SalesLeader]: 'gray10_100',
};

export const TEXT_COLOR = {
  [ELabelType.Reliable]: 'primary_100',
  [ELabelType.Problem]: 'white_100',
  [ELabelType.SalesLeader]: 'black_100',
};

export const ICON = {
  [ELabelType.Reliable]: <IconTrust12 />,
  [ELabelType.Problem]: <IconWarning16 color="white_100" />,
  [ELabelType.SalesLeader]: undefined,
};
